import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}`;
export const LOADING_BOX_IMG = `${ROOT}/h5/loading/box.png`;
export const YOO_FINDS_LOGO = `${ROOT}/h5/images/YooFindsLogo@2x.png`;
export const DEFAULT_SHOP_COVER = `${ROOT}/shops/default.webp`;
